.left {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.screen-title {
  text-transform: capitalize;
  font-size: 1.4rem;
  font-weight: 700;

  @media screen and (min-width: $bp-medium) {
    font-size: 1.4rem;
    font-weight: 500;
    color: #e3e4e7;
  }
}

.step-dead-line {
  display: flex;
  align-items: center;
  margin-left: 2.4rem;
}
